/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */
'use strict';

angular.module('accessWebClient')
    .factory('headerService', ['$translate', function ($translate) {
    var
        breadcrumbs = [];

    return {
        addBreadcrumbsItem: function(title, href){
            if (breadcrumbs && breadcrumbs.length > 0) {
                breadcrumbs[breadcrumbs.length - 1].current = false;
            }
            breadcrumbs.push({ name: title, href: href, current: true });
        },

        getBreadcrumbs: function() {
            return breadcrumbs;
        },

        reload: function() {
            breadcrumbs = angular.copy(breadcrumbs);
        },

        reset: function() {
            breadcrumbs = [];
        },

        addBreadcrumbsRootItem: function(title, href) {
            this.reset();
            this.rootName = title;
            this.addBreadcrumbsItem(title, href);
        },
        populateBreadcrumbs: function(currentNode, basePath) {
            var
                self = this;

            this.reset();

            this.addBreadcrumbsRootItem($translate.instant('Sync & Share'), basePath);
            angular.forEach(currentNode.parents, function(item){
                if (!item['is_root']) {
                    self.addBreadcrumbsItem(item.name, basePath + '/' + item.uuid);
                }
            });
        },
        
        rootName: '',
        
        basePath: '',
        
        loading: false
    };
}]);
